import { render, staticRenderFns } from "./research-list-folder.vue?vue&type=template&id=5fe6fb80&"
import script from "./research-list-folder.vue?vue&type=script&lang=ts&"
export * from "./research-list-folder.vue?vue&type=script&lang=ts&"
import style0 from "./research-list-folder.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports